<template>
  <div>
    <div class="h-dialogContainer" >
      <template>
        <ParseForm ref="basic" :formId="formItems.basic.formId" :formParams="formItems.basic.formObj" :opCode="opCode" :funcClick="bindClickInterface"></ParseForm>
      </template>
      <UsersubProfileList ref='profileList' :getCheckedDatas='getCheckedList' ></UsersubProfileList>
    </div>
  </div>
</template>

<script>
import ParseForm from '../../../util/parseFormNew/ParseForm';
import UsersubProfileList from "./UsersubProfileList";
import SubscriberTool from '../../../util/parseFormNew/tools/subscriberTool';
import ajaxUrl from "../../../data/ajaxUrl";

export default {
  name: "AddBatchUserForm",
  components: {
    ParseForm,
     UsersubProfileList,
  }, 
  methods: {
    getDatas() {
      const map = new Map();
      if (this.$refs.basic) {
        if (!this.$refs.basic.validateResult()) {
          console.log("表单验证不通过");
          return;
        }
        const maps = this.$refs.basic.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
      console.log(map);
      return map;
    },
    getJson(ne, callback) {
      this.ne = ne;
      const params = {
        msgid: this.msgId,
        neid: ne.neid,
      };
      this.$axios.post(ajaxUrl.udmJsonReq, params).then(response => {
        if (!response) {
          console.log("getJson response error");
          return;
        }
        if (!response.data) {
          console.log("getJson response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("getJson response.data.resultVal error");
          return;
        }
        if (response.data.errorCode !== "0") {
          console.log("getJson response.data.errorCode error");
          callback(response);
          return;
        }
        const res = response.data.resultVal;
        const sub = new SubscriberTool();
        const resultMap = sub.$devideByGroupBy(res, []);
        this.formItems.basic.formObj = resultMap.get(this.formItems.basic.modelName);
        callback(response);
      });      
    },
    saveBatchUser(ne, callback) {
      const formData = this.getDatas();
      if (formData) { 
        const params = { 
          vo: {    
            "neid": ne.neid,
            "supi": formData.get("supi"),
            "gpsi": formData.get("gpsi"),
            "count": parseInt(formData.get("count")),
            "randomKeyFlg": formData.get("randomKeyFlg"),
            "k": formData.get("k"),
            "amf": formData.get("amf"),
            "op": formData.get("op"),
            "userProfileId": formData.get("userProfileId"),
          }, 
          info: {
            msgid: this.msgId,
            neid: ne.neid,
          }
        };
        this.$axios.post(ajaxUrl.requestCommonD, params).then((response) => { 
          // const startSupi = formData.get("supi");
          // const opCount = formData.get("opCount");
          // const addUserList = [];
          // for (let i=0; i<opCount; i++) {
          //   addUserList.push({
          //     supi: (Number(startSupi) + i).toString(),
          //   })
          // }
          // if (callback) {
          //   callback(response, addUserList);
          // }
          if (callback) {
            callback(response);
          }
        });
      } 
    }, 
    getCheckedList(list) {
      if(this.$refs.basic) {
        this.$refs.basic.setData('userProfileId', list[0] || '');
      } 
    },
    onclickProfileId() {
      this.$refs.profileList.qryList(this.ne);
      this.$refs.profileList.show();
    },
  },
  computed: {
    bindClickInterface() { 
      this.funcMap = new Map();      
      this.funcMap.set('userProfileId', () => { this.onclickProfileId(); });
      return this.funcMap;
    }
  },
  data() {
    return {
      ne: null,
      id: 0,
      funcMap: null,
      list: [ 
      ],
      formItems: {
        basic: {
          formId: "SupiAddBatchBasicInfo",
          modelName: "basic",
          formObj: null,
        },
      }, 
      opCode: "add",
      msgId: "28696",
      timer1: null,
    };
  },
  beforeDestroy() {
  }
};
</script>
